
export default function TopMenu () {

    const menuData: any = [
        {name: 'Home', jumpLink: ""}, {name: 'Services', jumpLink: "#services"},
        {name: 'About us', jumpLink: "#about"}, {name: 'Contact us', jumpLink: "#contacts"}
    ]

    const menuElems = menuData.map((item: string, index: number) => {
        return <div key={index}>
            <a href={menuData[index]['jumpLink']} className="menu-item-link">{menuData[index]['name']}</a>
        </div>
    })

    return (

        <div className="top-menu-block">

            <div className="top-menu-logo">
                {/*<img src="/images/acepim_logo_v1.png" alt="acepim logo" width="240" height="60"/>*/}
                <img src="/images/acepim_logo_v2.png" alt="acepim logo" className="logo-picture"/>
                <div className="logo-name">acepim</div>
            </div>

            <div className="top-menu-items">
                {menuElems}
            </div>

        </div>
    )
}